import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataMainReducer from '../static-data.reducer';
import { IndividualsState, individualsFeatureKey } from '../reducers/individuals.reducer';
import * as fromStaticDataIndividualsReducer from '../reducers/individuals.reducer';

//#region Static Data ROOT STATE
export const getStaticDataState = createFeatureSelector<fromStaticDataMainReducer.State, IndividualsState>(
  fromStaticDataMainReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataIndividualsState = createSelector(getStaticDataState, state => state[fromStaticDataIndividualsReducer.individualsFeatureKey]);

export const getStaticDataIndividualsFailure = createSelector(getStaticDataIndividualsState, fromStaticDataIndividualsReducer.getIndividualsFailure);

export const getStaticDataIndividualsResponse = createSelector(getStaticDataIndividualsState, fromStaticDataIndividualsReducer.getIndividualsResponse);
